var map = {
	"./app": [
		913,
		9
	],
	"./app.js": [
		913,
		9
	],
	"./blocks/news": [
		5113,
		9,
		1740,
		5113
	],
	"./blocks/news.js": [
		5113,
		9,
		1740,
		5113
	],
	"./blocks/tabs": [
		3696,
		7,
		3696
	],
	"./blocks/tabs.js": [
		3696,
		7,
		3696
	],
	"./blocks/team": [
		9142,
		9,
		9142
	],
	"./blocks/team.js": [
		9142,
		9,
		9142
	],
	"./blocks/video": [
		4403,
		9,
		4403
	],
	"./blocks/video.js": [
		4403,
		9,
		4403
	],
	"./classes/breakpoint": [
		8443,
		9,
		8443
	],
	"./classes/breakpoint.js": [
		8443,
		9,
		8443
	],
	"./classes/scroll-controller": [
		8145,
		9,
		8145
	],
	"./classes/scroll-controller.js": [
		8145,
		9,
		8145
	],
	"./classes/scroll-locker": [
		3800,
		9,
		3800
	],
	"./classes/scroll-locker.js": [
		3800,
		9,
		3800
	],
	"./classes/validation": [
		3771,
		9,
		3771
	],
	"./classes/validation.js": [
		3771,
		9,
		3771
	],
	"./classes/video-embed": [
		7732,
		9,
		7732
	],
	"./classes/video-embed.js": [
		7732,
		9,
		7732
	],
	"./cms": [
		961,
		9,
		961
	],
	"./cms.js": [
		961,
		9,
		961
	],
	"./cms/colourpalette": [
		5387,
		7,
		5387
	],
	"./cms/colourpalette.js": [
		5387,
		7,
		5387
	],
	"./cms/darkmode": [
		7371,
		9,
		7371
	],
	"./cms/darkmode.js": [
		7371,
		9,
		7371
	],
	"./cms/field-names": [
		5142,
		9,
		5142
	],
	"./cms/field-names.js": [
		5142,
		9,
		5142
	],
	"./cms/modal": [
		3574,
		9,
		3574
	],
	"./cms/modal.js": [
		3574,
		9,
		3574
	],
	"./cms/page-observer": [
		1623,
		9,
		1623
	],
	"./cms/page-observer.js": [
		1623,
		9,
		1623
	],
	"./cms/title": [
		9802,
		7,
		9802
	],
	"./cms/title.js": [
		9802,
		7,
		9802
	],
	"./cms/wysiwyg-modal": [
		5748,
		7,
		5748
	],
	"./cms/wysiwyg-modal.js": [
		5748,
		7,
		5748
	],
	"./components/breakpoint": [
		6398,
		9,
		6398
	],
	"./components/breakpoint.js": [
		6398,
		9,
		6398
	],
	"./components/equalizer": [
		8159,
		9,
		8159
	],
	"./components/equalizer.js": [
		8159,
		9,
		8159
	],
	"./components/in-view": [
		1316,
		9,
		1316
	],
	"./components/in-view.js": [
		1316,
		9,
		1316
	],
	"./components/lazy-load": [
		4497,
		9,
		4497
	],
	"./components/lazy-load.js": [
		4497,
		9,
		4497
	],
	"./components/parallax": [
		1960,
		9,
		1960
	],
	"./components/parallax.js": [
		1960,
		9,
		1960
	],
	"./components/scroll": [
		8483,
		9,
		8483
	],
	"./components/scroll-to": [
		9867,
		9,
		9867
	],
	"./components/scroll-to.js": [
		9867,
		9,
		9867
	],
	"./components/scroll.js": [
		8483,
		9,
		8483
	],
	"./components/selectors": [
		3701,
		9,
		3701
	],
	"./components/selectors.js": [
		3701,
		9,
		3701
	],
	"./critical": [
		4434,
		9,
		4434
	],
	"./critical.js": [
		4434,
		9,
		4434
	],
	"./editor": [
		2043,
		9,
		2043
	],
	"./editor.js": [
		2043,
		9,
		2043
	],
	"./elements/accordion": [
		7609,
		9,
		7609
	],
	"./elements/accordion.js": [
		7609,
		9,
		7609
	],
	"./elements/contact-form": [
		7079,
		9,
		7079
	],
	"./elements/contact-form.js": [
		7079,
		9,
		7079
	],
	"./elements/contact-modal": [
		5262,
		9,
		5262
	],
	"./elements/contact-modal.js": [
		5262,
		9,
		5262
	],
	"./elements/fund-details": [
		3589,
		9,
		1740,
		3589
	],
	"./elements/fund-details.js": [
		3589,
		9,
		1740,
		3589
	],
	"./elements/funds-navigation": [
		5912,
		9,
		1740,
		5912
	],
	"./elements/funds-navigation.js": [
		5912,
		9,
		1740,
		5912
	],
	"./elements/header": [
		504,
		9,
		504
	],
	"./elements/header.js": [
		504,
		9,
		504
	],
	"./elements/mega-menu": [
		8850,
		7,
		8850
	],
	"./elements/mega-menu.js": [
		8850,
		7,
		8850
	],
	"./elements/mobile-menu": [
		9925,
		7,
		9925
	],
	"./elements/mobile-menu.js": [
		9925,
		7,
		9925
	],
	"./elements/performance-tables": [
		2782,
		9,
		1740,
		2782
	],
	"./elements/performance-tables.js": [
		2782,
		9,
		1740,
		2782
	],
	"./elements/resources": [
		5121,
		7,
		5121
	],
	"./elements/resources.js": [
		5121,
		7,
		5121
	],
	"./elements/search": [
		6719,
		9,
		6719
	],
	"./elements/search.js": [
		6719,
		9,
		6719
	],
	"./elements/subscription-form": [
		6289,
		9,
		6289
	],
	"./elements/subscription-form.js": [
		6289,
		9,
		6289
	],
	"./elements/unit-price": [
		7614,
		9,
		1740,
		7614
	],
	"./elements/unit-price.js": [
		7614,
		9,
		1740,
		7614
	],
	"./graphs/investment-mix": [
		6091,
		9,
		8597,
		6091
	],
	"./graphs/investment-mix.js": [
		6091,
		9,
		8597,
		6091
	],
	"./graphs/performance": [
		3470,
		9,
		8597,
		3470
	],
	"./graphs/performance.js": [
		3470,
		9,
		8597,
		3470
	],
	"./pages/blog": [
		7925,
		9,
		7925
	],
	"./pages/blog.js": [
		7925,
		9,
		7925
	],
	"./pages/fund-holder": [
		9162,
		7,
		9162
	],
	"./pages/fund-holder.js": [
		9162,
		7,
		9162
	],
	"./pages/search-results": [
		1263,
		9,
		1263
	],
	"./pages/search-results.js": [
		1263,
		9,
		1263
	],
	"./pages/team": [
		6118,
		9,
		6118
	],
	"./pages/team.js": [
		6118,
		9,
		6118
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 8664;
module.exports = webpackAsyncContext;